import { useNavigate, } from "react-router-dom";
import { AbsoluteCenter, Box, Button, Center, Image, Heading, Stack, Text, } from "@chakra-ui/react";
import exclam from "../../../../assets/exclamation.svg";
import { RoutesMap, } from "../../../../routes.tsx";

export function CameraDeniedView() {
  const navigate = useNavigate();
  return (
    <Box h="100vh" maxW="320px" mx="auto" position="relative">
      <AbsoluteCenter w="100%">
        <Box>
          <Stack spacing={4}>
            <Center>
              <Image src={exclam} />
            </Center>

            <Box>
              <Heading textAlign="center" mb={2}>
                Доступ к камере ограничен
              </Heading>
              <Text textAlign="center">
                Проверьте настройки доступа и попробуйте ещё раз
              </Text>
            </Box>

            <Button
              colorScheme="black"
              w="100%"
              onClick={() => {
                window.location.reload();
              }}
            >
              Обновить
            </Button>

            <Button
              onClick={() => {
                navigate(RoutesMap.index,);
              }}
            >
              Вернуться на главную
            </Button>
          </Stack>
        </Box>
      </AbsoluteCenter>
    </Box>
  );
}
